import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type CompanyModel from './company.ts';
import type UserModel from './user.ts';
import type FinancialInstitutionModel from './financial-institution.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class PostalAddressModel extends Model {
  @attr declare addressLine1: string;
  @attr declare addressLine2: string;
  @attr declare addressLine3: string;
  @attr declare city: string;
  @attr declare state: string;
  @attr declare postalCode: string;
  @attr declare country: string;
  @attr declare isActive: boolean;
  @attr declare isVerified: boolean;
  @attr declare postalAddressType: string;
  @attr declare paymentMethodType: string;
  @attr declare servicerAddressIdentifier?: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;

  @belongsTo('financial-institution', { async: false, inverse: null })
  declare financialInstitution: FinancialInstitutionModel;

  @belongsTo('postal-addressable', {
    async: false,
    polymorphic: true,
    inverse: 'postalAddresses',
  })
  declare postalAddressable: CompanyModel | FinancialInstitutionModel;

  //* Computed Properties */
  get isPayment() {
    return this.postalAddressType === 'PAYMENT';
  }

  [Type] = 'postal-address' as const;
}
